export const LOCAL_COPILOT = 'LOCAL_COPILOT';